module.exports = __webpack_public_path__ + "img/dmp-banner.7a78608f.png";